<template>
  <div>
    <el-table
      v-if="mpAdvertiserList.length!==0"
      :data="mpAdvertiserList"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="80"
      />
      <el-table-column
        prop="account_id"
        label="广告主id"
      />
      <el-table-column
        prop="account_name"
        label="广告主名称"
        show-overflow-tooltip
      />
      <el-table-column
        prop="account_status_text"
        label="账户状态"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="choose(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { advertiserList } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      platform: null, // 平台
      tableData: [],
      advertisersQuery: {
        account_id: null,
        account_name: null,
        type: null,
        account_status: null,
        page: null, // 当前页码
        pageSize: null // 显示数据条数
      },
      mpAdvertiserList: [],
      total: null // 总页数
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.fetchMpAdvertiserList()
    },
    // 获取阅文列表
    fetchMpAdvertiserList() {
      this.isLoading = true
      advertiserList(this.mpAdvertiserListParams).then(res => {
        console.log(res, '5555')

        this.mpAdvertiserList = res.data.list
        // const duplicateData = JSON.parse(JSON.stringify(res.data.list[0]))
        // res.data.list[0].id = 5
        // this.mpAdvertiserList = [res.data.list[0], duplicateData]
        this.total = res.data.count
        this.isLoading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.pageSize = e
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    // 重置
    reset() {
      this.parmrs.page = 1
      this.parmrs.pageSize = 10
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    choose(item) {
      console.log(item)
      this.$emit('close', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
